import AccountPageNav from '../../views/account/components/AccountPageNav/AccountPageNav';
import { BasePageLayoutProps } from '../BasePageLayout/BasePageLayout';
import BasePageTemplate from '../BasePageTemplate/BasePageTemplate';
import HeaderAndFooter from '../HeaderAndFooter/HeaderAndFooter';
import PageContent from '../PageContent/PageContent';
import { FullPageLoader } from '../../components/Loader/Loader';
import CustomerSupportInfo from '../../v2/common/CustomerSupportInfo';

interface AccountPageLayoutProps extends BasePageLayoutProps {
  loading?: boolean;
}
const AccountPageLayout = ({ children, title, loading = false, }: AccountPageLayoutProps) => {
  return (
    <BasePageTemplate>
      <HeaderAndFooter title={title}>
        <PageContent>
            <div className="mb-8">
              <CustomerSupportInfo />
            </div>
          <AccountPageNav />
          {loading ? (
              <FullPageLoader />
          ) : (
            children
          )}
        </PageContent>
      </HeaderAndFooter>
    </BasePageTemplate>
  );
};
export default AccountPageLayout;
